export default __webpack_public_path__ + "static/media/bg-rates.1c2db252.png";